export default __webpack_public_path__ + "static/media/women.214e2aec.jpg";